import {toCamelCase} from "@ergeon/erg-utils-js";
import {AuthUser} from "v2/api/Records";

export const apiAuthUser = (user) => {
  // Ensure that user data is camelcased
  user = toCamelCase(user);
  return new AuthUser({
    ...user,
  });
};

export default {
  apiAuthUser,
};



/** WEBPACK FOOTER **
 ** ./src/app/v2/api/Auth.js
 **/